import React, { useContext } from 'react'
import LeftContent from 'modules/react/signup/LeftContent'
import RightContent from 'modules/react/signup/RightContent'
import SignupContext from 'modules/react/signup/SignupContext'
import FormElementError from 'modules/react/signup/FormElementError'
import CourseSummary from 'modules/react/signup/CourseSummary'
import CourseDateSelection from 'modules/react/signup/CourseDateSelection'
import InputMask from 'react-input-mask'
import NewsletterCheckbox from 'modules/react/signup/NewsletterCheckbox'

export default function Step2Unemployed () {

  const signupContext = useContext(SignupContext)
  const { submit, goBack, setFormValue, getFormValue, goToNextStep, restUrls, setEnterCallback } = signupContext

  const [signUpForSixWeeks, setSignUpForSixWeeks] = React.useState(false)

  React.useEffect(() => {
      setEnterCallback(() => validateStepData)
    }, []
  )

  const validateStepData = () => {
    submit(restUrls.unemployed.personal)
      .then((response) => {
        goToNextStep()
      })
  }

  const handleSixWeeksChange = (doSignUp) => {
    setFormValue('sign_up_for_job', doSignUp)
    setSignUpForSixWeeks(doSignUp)
  }

  return (
    <>
      <LeftContent>
        <div className="title title--h3">Udfyld dine oplysninger</div>
        <CourseDateSelection/>
        <div className="title title--h6">Udfyld oplysninger</div>
        <div className="input-group">
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="firstName">
                <input type="text" placeholder="Fornavn" onChange={(e) => setFormValue('firstName', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="lastName">
                <input type="text" placeholder="Efternavn" onChange={(e) => setFormValue('lastName', e.target.value)}/>
              </FormElementError>
            </div>
          </div>
          <div className="input-wrap">
            <FormElementError name="cpr">
              <InputMask
                type="text" placeholder="CPR-nr" onChange={(e) => setFormValue('cpr', e.target.value)}
                mask="999999-9999" disableUnderline maskChar={null}
              />
            </FormElementError>
          </div>
          <div className="input-group__half">
            <div className="input-wrap">
              <FormElementError name="phone">
                <input type="text" placeholder="Telefonnr" onChange={(e) => setFormValue('phone', e.target.value)}/>
              </FormElementError>
            </div>
            <div className="input-wrap">
              <FormElementError name="email">
                <input type="text" placeholder="Email" onChange={(e) => setFormValue('email', e.target.value.trim())}/>
              </FormElementError>
            </div>
          </div>
        </div>
        <div className="title title--h8">Vælg</div>
        <div className="input-group">
          <div className="wysiwyg">Som ledig kan du deltage på en af disse ordninger:
          </div>
          <div className="input-group radio-group">
            <div className="radio-button">
              <input type="radio" id="yes" name="sign_up_for_job"
                     onChange={(e) => handleSixWeeksChange(true)}/>
              <label htmlFor="yes">6 ugers jobrettet uddannelse</label>
            </div>
            <div className="radio-button">
              <input type="radio" id="no" name="sign_up_for_job"
                     onChange={(e) => handleSixWeeksChange(false)}/>
              <label htmlFor="no">Kursus fra de regionale positivlister</label>
            </div>
          </div>
          <div className="wysiwyg wysiwyg--fs14">Hvis du ikke har en aftale om uddannelse med din a-kasse eller dit
            jobcenter anbefaler vi, at du kontakter dem for at få mere at vide om dine muligheder.
          </div>
        </div>
        <NewsletterCheckbox/>
        <div className="button-section button-section--modal-group">
          <button className="inline-button inline-button--prim inline-button--back" onClick={goBack}>Tilbage
          </button>
          <button className="button button--next" onClick={validateStepData}>Tag mig videre</button>
        </div>
      </LeftContent>
      <RightContent>
        <CourseSummary paymentType={signUpForSixWeeks ? 'Jobcenter' : 'Egenbetaling'}/>
      </RightContent>
    </>
  )
}